import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { t } from 'i18next';
import React from 'react';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import {
  MatchStyledText,
  StyledFlexWithGapAndNoWrap,
  TextAndViewLocationsContainer,
} from '../../SmartChoiceBreakDown.styles';
import { StyledButton } from '../BenfitsBreakDown.styles';

interface NotMatchTextWithTierLocationsProps {
  text: string;
  EndIcon?: React.ReactNode;
  handleTabChange?: (tab: number) => void;
  isCost?: boolean;
  isViewLink?: boolean;
}
export const NotMatchTextWithTierLocations = ({
  text,
  handleTabChange,
  isCost,
  isViewLink,
}: NotMatchTextWithTierLocationsProps) => (
  <StyledFlexWithGapAndNoWrap
    alignItems="flex-start"
    data-testid="not-match-tier1-with-location"
    direction="row"
  >
    <StyledFlexWithGapAndNoWrap>
      <IconSymbol color="#990000" icon="do_not_disturb" />
    </StyledFlexWithGapAndNoWrap>

    <TextAndViewLocationsContainer alignItems="flex-start" direction="column">
      <MatchStyledText>{text}</MatchStyledText>
      {isViewLink && (
        <StyledButton
          data-testid="view-locations-benifits"
          onClick={() => {
            adobeLinkTrackEvent({
              name: `View ${isCost ? 'Costs' : 'Locations'}`,
              location: 'Smart choice benefits breakdown',
            });
            handleTabChange?.(isCost ? 3 : 1);
          }}
          variant="tertiary"
        >
          {t(`SMART_CHOICE.VIEW_${isCost ? 'COSTS' : 'LOCATIONS'}`)}
          <IconSymbol icon="chevron_right" size={16} />
        </StyledButton>
      )}
    </TextAndViewLocationsContainer>
  </StyledFlexWithGapAndNoWrap>
);
